module.exports = __webpack_public_path__ + "static/angular-1c257e6b895be11a751adc1080aab428.jpg";